import { NAME } from './constants';

export const LOAD_BY_ID = `${NAME}/LOAD_BY_ID`;
export const LOAD_BY_CARRIER_FLIGHT_NUMBER_AND_DATE = `${NAME}/LOAD_BY_CARRIER_FLIGHT_NUMBER_AND_DATE`;
export const LOAD_EXTENDED_DETAILS_BY_CARRIER_FLIGHT_NUMBER_AND_DATE = `${NAME}/LOAD_EXTENDED_DETAILS_BY_CARRIER_FLIGHT_NUMBER_AND_DATE`;
export const LOAD_EXTENDED_SUCCESS = `${NAME}/LOAD_EXTENDED_SUCCESS`;
export const LOAD_SUCCESS = `${NAME}/LOAD_SUCCESS`;
export const LOAD_FAIL = `${NAME}/LOAD_FAIL`;
export const LOAD_BY_CARRIER_FLIGHT_NUMBER_AND_DATE_SUCCESS = `${NAME}/LOAD_BY_CARRIER_FLIGHT_NUMBER_AND_DATE_SUCCESS`;
export const LOAD_BY_ID_SUCCESS = `${NAME}/LOAD_BY_ID_SUCCESS`;
export const UPDATE_SEGMENTS = `${NAME}/UPDATE_SEGMENTS`;
export const SET_SECONDARY_SEARCH_ACTION = `${NAME}/SET_SECONDARY_SEARCH_ACTION`;



// WEBPACK FOOTER //
// ./modules/SingleFlight/redux/actionTypes.js